<template>
  <div>
    <h1 class="text-jumbo mb-[12px] max-w-max">{{ header }}</h1>
    <p class="text-grey-body text-lead max-w-[800px]">
      {{ content }}
    </p>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BGCHeader',
  props: {
    userType: {
      type: Object,
      required: true,
    },
  },
  computed: {
    content() {
      if (this.userType.isCorporate)
        return 'Your membership includes background checks to help you hire with confidence. Get one check at no cost and additional options for a discounted rate.';
      else if (this.userType.isPremium)
        return 'Looking for extra peace of mind? Background checks are available to Premium members and can be purchased directly from caregiver profiles. Background check fees are based on which type you’d like to run.';
      else if (this.userType.isBasic)
        return 'Need extra peace of mind? Upgrade to Premium to request background checks directly from caregiver profiles. Background check fees apply: Basic, $25; Enhanced Criminal, $75; Motor Vehicle, $38).';
      return '';
    },
    header() {
      if (this.userType.isBasic) return 'Unlock background checks for your caregivers';
      return 'Background checks for your caregivers';
    },
  },
};
</script>

<style></style>
